module.exports = __webpack_public_path__ + "img/tumblr_npn8r7aapq1rwpvelo1_540.jpg";